<template>
  <div style="background: #F6F7F8;height: 100vh;overflow-y: auto">
      <div style="position: relative;padding: 41.87vw 0">
          <img src="../../../assets/img/mineBg.png" style="position: absolute;width: 100vw;top: 0;left: 0">
          <div class="mineItem" style="">
              <div style="margin: 0 auto;width: 16.54vw">
                  <img src="../../../assets/img/defaultAvatar.png" style="width: 16.54vw;margin-top: -5.6vw">
              </div>
              <div style="text-align: center;color: #484848;font-size: 5vw;font-weight: bold;margin-top: 3.73vw">
                  {{userData.userName}}
              </div>
              <div style="width: 100%;height: .13vw;background: #ececec;margin: 3.73vw auto 0"></div>
              <div style="font-size: 4vw;font-weight: bold;margin: 9.6vw 0">
                  我的订单
              </div>
              <div class="centerBox" style="justify-content: space-between">
                  <div @click="$router.push('/myOrder?index=5')">
                     <img src="../../../assets/img/mine/shz.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw">
                          审核中
                      </div>
                  </div>
                  <div @click="$router.push('/myOrder?index=2')">
                      <img src="../../../assets/img/mine/ysh.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw">
                          已审核
                      </div>
                  </div>
                  <div @click="$router.push('/myOrder?index=3')">
                      <img src="../../../assets/img/mine/yfk.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw">
                          已付款
                      </div>
                  </div>
                  <div @click="$router.push('/myOrder?index=8')">
                      <img src="../../../assets/img/mine/yjs.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw">
                          已结束
                      </div>
                  </div>
              </div>
          </div>
          <div class="mineItem" style="margin-top: 4.8vw;padding-top: 4.27vw">
              <div class="centerBox" style="justify-content: space-between">
                  <div @click="test">
                      <img src="../../../assets/img/mine/sc.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw;text-align: center">
                          收藏
                      </div>
                  </div>
                  <div @click="test">
                      <img src="../../../assets/img/mine/kf.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw;text-align: center">
                          客服
                      </div>
                  </div>
                  <div @click="test">
                      <img src="../../../assets/img/mine/ts.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw;text-align: center">
                          投诉
                      </div>
                  </div>
                  <div @click="test">
                      <img src="../../../assets/img/mine/sz.png" style="width: 10.4vw">
                      <div style="font-size: 3.47vw;color: #484848;margin-top: 2.4vw;text-align: center">
                          设置
                      </div>
                  </div>
              </div>
          </div>
          <div class="mineItem" @click="outLogin" style="margin-top: 4.8vw;padding: 6.13vw 8.8vw">
              <div class="centerBox">
                  <img src="../../../assets/img/icon/close.png" style="width: 4vw;margin-right: 1.3vw">
                  <div style="font-size: 3.73vw;color: #484848">
                      退出登录
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'mine',
  data () {
    return {
      show: false,
      showIcon: false,
      downShow: false,
      downHJShow: false,
      userTeamShow: false,
      icon: {
      },
      levelUpShow: false,
      form: {
        growthValue: 0,
        nickName: '',
        memberLevel: 0,
        newSysFlag: 1,
        showCert: 0
      },
      downText: '',
      agentFlag: 0,
      orderNum: {
        afterSales: 0,
        delivered: 0,
        paid: 0,
        received: 0,
        unpaid: 0
      },
      realNameFlag: 0,
      balanceInfo: {
        userBalance: 0
      },
      couponQtyInfo: {},
      plusInfo: {},
        userData: {}
    }
  },
  created () {
    this.userInfo()
    // this.getCode('123')
  },
  activated () {
  },
  methods: {
    ...mapActions([
      'set_userInfo'
    ]),
      outLogin () {
          let noMessageShow = !!window.localStorage.noMessage
          window.localStorage.clear()
          if (noMessageShow) {
              window.localStorage.setItem('noMessage', '1')
          }
          this.$router.push('/login')
      },
    toLevelUp () {
      this.levelUpShow = false
      setTimeout(() => {
        this.rightLevel()
      }, 300)
    },
    cancleLevelUp () {
      this.$request.shop.editUpGradeKnow()
      this.levelUpShow = false
    },
    showMember3 () {
      const self = this
      let loading = self.$toast.loading({
        duration: 0
      })
      self.$request.shop.query()
        .then((response) => {
          loading.clear()
          if (response.code === '200') {
            if (response.data.growthValue >= 3980 && !response.data.knowFlag) {
              this.levelUpShow = true
            }
          } else {
            self.$toast(response.msg)
          }
        })
    },
    test () {
      this.$toast('暂未开通')
    },
    toFit () {
      this.$toast.loading()
      this.$request.fitCert.selectFitCert()
        .then((response) => {
          this.$toast.clear()
          if (response.code !== '200') {
            this.$toast(response.msg)
          }
          if (!response.data.url) {
            this.$router.push('/fitChange')
          } else {
            this.$router.push('/fitDetail')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toSM () {
      if (!this.realNameFlag) {
        // this.$toast('银行系统升级，实名认证功能暂停！')
        this.$router.push('/authenticationReal')
      }
    },
    rightLevel () {
      this.$dialog.confirm({
        message: '升级铂金会员，需放弃现有Plus优惠券，铂金优惠与Plus优惠不可同时使用',
        title: '升级铂金'
      }).then(() => {
        this.$request.mineMessage.userUpgrade(3)
          .then((response) => {
            this.$toast(response.msg)
            if (response.code === '200') {
              setTimeout(() => {
                this.userInfo()
              }, 500)
            }
          })
      })
    },
    rightButton () {
      if (this.form.memberLevel === 1) {
        if (this.form.growthValue / 100 < 3980) {
          return
        }
        this.rightLevel()
      } else {
        this.downLevel()
      }
    },
    leftLevel () {
      this.downHJShow = true
    },
    downLevel () {
      this.downShow = true
    },
    userInfo () {
      const self = this
      let loading = self.$toast.loading({
        duration: 0
      })
      self.$request.login.getDzUser()
        .then((response) => {
          loading.clear()
          self.userData = response.data
        })
    },
    findNew () {
      let self = this
      this.$request.wallet.isAgent()
        .then((response) => {
          self.agentFlag = response.data.agentFlag
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
    .mineItem {
        margin: 0 auto;
        width: calc(92vw - 8.8 * 2vw);
        border-radius: 1.6vw;
        position: relative;
        background: white;
        padding: 0 8.8vw 6.93vw;
    }
</style>
